<script setup>
import DataFilterMobile from './DataFilterMobile.vue'

const props = defineProps({
  filters: {
    type: Array,
    required: true,
  },
  maxFilterControls: {
    type: Number,
    default: 3,
  },
})

const singleFilters = computed(() => {
  return props.filters.length > props.maxFilterControls ? props.filters.slice(0, props.maxFilterControls - 1) : props.filters
})
const moreFilters = computed(() => {
  return props.filters.length > props.maxFilterControls ? props.filters.slice(props.maxFilterControls - 1) : undefined
})

const { t } = useI18n()

const isMobileMenuOpen = ref(false)
const mobile_collapse = ref(null)

watch(isMobileMenuOpen, (val) => {
  const collapse = mobile_collapse.value
  if (val)
    collapse.show()
  else collapse.hide()
})

function toggleMobileMenu() {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}
</script>

<template>
  <div class="relative flex flex-col gap-2 md:!hidden">
    <slot name="customFilter" />
    <DataFilterSingle
      v-for="(filter, index) in singleFilters"
      :key="`filter_${index}`"
      :filter="filter"
    />
    <button
      v-if="moreFilters"
      class="h-40px w-full flex flex-row cursor-default items-center justify-center flex-gap-x-2 rounded bg-white px-4 py-2 text-left shadow-none ring-1 ring-surface-700 ring-inset lt-sm:text-sm"
      :class="[isMobileMenuOpen ? 'ring-secondary' : 'ring-surface-700']"
      @click="toggleMobileMenu()"
    >
      <div
        class="shrink-0 text-secondary"
        aria-hidden="true"
      >
        <DSIcon
          v-if="!isMobileMenuOpen"
          size="24"
          icon="i-far-plus"
        />
        <DSIcon
          v-else
          size="24"
          icon="i-far-minus"
        />
      </div>
      <div>
        <span
          v-if="!isMobileMenuOpen"
          class="text-text-500"
        >{{ t('Add Filter') }}</span>
        <span
          v-else
          class="text-text-500"
        >{{ t('Hide Filters') }}</span>
      </div>
      <div
        class="shrink-0"
        aria-hidden="true"
      >
        <DSIcon
          v-if="!isMobileMenuOpen"
          size="24"
          icon="i-far-chevron-down"
        />
        <DSIcon
          v-else
          size="24"
          icon="i-far-chevron-up"
        />
      </div>
    </button>
    <DSCollapse
      ref="mobile_collapse"
    >
      <div class="my-1 w-full flex flex-col flex-gap-1">
        <DataFilterMobile
          v-for="(filter, index) in moreFilters"
          :key="`filter_${index}`"
          :filter="filter"
        />
      </div>
    </DSCollapse>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Add Filter": "Add Filter",
    "Hide Filters": "Hide Filters"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Add Filter": "Filter hinzufügen",
  "Hide Filters": "Filter ausblenden"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Add Filter": "Ajouter un filtre",
  "Hide Filters": "Masquer les filtres"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Add Filter": "Añadir filtro",
  "Hide Filters": "Ocultar filtros"
}
</i18n>
